/* Built In Imports */
/* External Imports */
import { Box, Heading, Image } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import GoYSimpleCard from '@landing_pages/GoY/GoYSimpleCard';

/* Services */

/**
 * 
 * @param {Object} param0 
 * @returns 
 */
const ProgramHighlights = ({ section }) => {
  return (
    <Box
      mr={{ lg: '70px' }}
      // mt="30px"
      bgColor="#3c1005"
      clipPath={{
        lg: 'polygon(0 0%, 100% 0, 100% 100%, 0% 90%)',
        md: 'polygon(0 0%, 100% 0, 100% 100%, 0% 98%)',
        base: 'polygon(0 0%, 100% 0, 100% 100%, 0% 95%)',
      }}
      pr={{
        lg: 'calc((100% - 1112px ) / 2)',
        md: '18px',
        sm: '18px',
      }}
      pl={{
        lg: 'calc((100% - 1112px ) / 2)',
        md: '18px',
        sm: '18px',
      }}
      pb={{ lg: '100px', md: '60px', sm: '50px' }}
      width="100%"
      color="#ffffff"
    >
      <Box
        display="flex"
        width="100%"
        flexWrap="wrap"
        textAlign="center"
        justifyContent="center"
        p={{ base: "0", md: "0px 20px" }}
        pb={{ base: '60px', lg: 'unset', md: 'unset' }}
      >
        <Box
          textAlign="center"
          width="100%"
          mt={{ lg: '76px', base: '60px' }}
        >
          <Heading
            as="h2"
            fontFamily="FedraSansStd-A-medium, sans-serif"
            fontSize={{ lg: '30px', md: '30px', base: '20px' }}
            color="#ffffff"
            fontWeight="normal"
          >
            {section?.sectionContent[0]?.title[0]?.titleText}
          </Heading>
          <Image
            src="https://www.datocms-assets.com/46272/1637138848-subhead-linear-white.png"
            mb="16px"
          />
        </Box>
        {section?.sectionContent?.length > 0 && (
          <GoYSimpleCard simpleCardData={section?.sectionContent[0]} />
        )}
      </Box>
    </Box>
  );
};

export default ProgramHighlights;
